// @flow
import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import styled from 'styled-components';

import { StyledMenuItem } from '../../common-utils/styledComponents';
import { useToggleAdminModeMutation } from '../../service-definitions/estimates';
import { useIsCE2 } from '../../custom-hooks/useIsCE2';
import { useUser } from '../../custom-hooks/useUser';
import { toastError } from '../presentational/notifications/utils';
import {
  IS_ADMIN_MODE_TOGGLE_LIVE,
  ADMIN_NONADMIN_TOGGLE_ALLOWED_EMAILS_BY_ENV,
} from '../../constants';
import { isEmailAllowedForFeature } from '../../common-utils/utils';
import { Spacer } from '../presentational/spacing/Spacer';

const StyledAdminNonAdminToggle = styled(Checkbox)`
  &&&.ui.toggle.checkbox label:before {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

export const AdminNonAdminSwitchingToggle = () => {
  const { isAdmin: isUserActingAsAdmin, email } = useUser();
  const isCE2 = useIsCE2();
  const [toggleAdminMode] = useToggleAdminModeMutation();

  // Admin Toggle Mode is not applicable for CE2
  if (isCE2) {
    return null;
  }

  if (!IS_ADMIN_MODE_TOGGLE_LIVE) {
    return null;
  }

  // Admin/Non-Admin toggle mode is only available for allowed emails per environment
  if (!isEmailAllowedForFeature(ADMIN_NONADMIN_TOGGLE_ALLOWED_EMAILS_BY_ENV, email)) {
    return null;
  }

  const handleToggle = async () => {
    const { error } = await toggleAdminMode({ admin: !isUserActingAsAdmin });
    if (error) {
      toastError(error);
      return;
    }
    window.location.reload();
  };

  return (
    <StyledMenuItem>
      <StyledAdminNonAdminToggle
        checked={isUserActingAsAdmin}
        onChange={handleToggle}
        toggle={true}
      />
      <Spacer x={8} />
      {isUserActingAsAdmin ? 'Admin' : 'Non-Admin'}
    </StyledMenuItem>
  );
};
